export default {
  title: {
    text: "CMP抛光材料占比",
    left: "center",

    textStyle: {},
  },
  tooltip: {
    trigger: "item",
    formatter: "{a} <br/>{b} : {c} ({d}%)",
  },

  series: [
    {
      name: "占比",
      type: "pie",
      radius: "50%",
      center: ["50%", "50%"],
      data: [
        {
          value: 49,
          name: "抛光液",
        },
        {
          value: 33,
          name: "抛光垫",
        },
        {
          value: 9,
          name: "调节器",
        },
        {
          value: 5,
          name: "清洗",
        },
        {
          value: 4,
          name: "其他",
        },
      ],
      emphasis: {
        itemStyle: {
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowColor: "rgba(0, 0, 0, 0.5)",
        },
      },
    },
  ],
};
